/* eslint-disable react/jsx-no-target-blank */
import { useIntl } from 'react-intl'
import { AsideMenuItem } from './AsideMenuItem'
import { AsideMenuItemWithSub } from './AsideMenuItemWithSub'
import { usePermissionChecker } from '../../../../app/hooks/PermissionChecker'
import { LIST_PERMISSIONS } from '../../../../app/constants/common'
export function AsideMenuMain() {
  const intl = useIntl()
  const { hasPermission } = usePermissionChecker();

  return (
    <>
      <AsideMenuItem
        to='/dashboard'
        icon='/media/icons/duotune/art/art002.svg'
        title={intl.formatMessage({ id: 'MENU.DASHBOARD' })}
        fontIcon='bi-app-indicator'
      />
      {hasPermission(LIST_PERMISSIONS.PRODUCTS) && (
        <AsideMenuItem
          to='/products'
            icon='/media/icons/duotune/abstract/abs027.svg'
            title={intl.formatMessage({ id: 'MENU.PRODUCTS' })}
            fontIcon='bi-app-indicator'
        />
      )}
      {hasPermission(LIST_PERMISSIONS.IMPORT_REQUEST) && (
        <AsideMenuItemWithSub
          to='/warehouse'
          icon='/media/icons/duotune/ecommerce/ecm006.svg'
          title={intl.formatMessage({ id: 'MENU.WAREHOUSE_MANAGEMENT' })}
          fontIcon='bi-app-indicator'
        >
          {hasPermission(LIST_PERMISSIONS.IMPORT_REQUEST) && (
            <AsideMenuItem to='/warehouse/receipt/import-requests' title={'Yêu cầu nhập hàng'} hasBullet />
          )}
          {hasPermission(LIST_PERMISSIONS.WAREHOUSE_LOGS) && (
            <AsideMenuItem to='/warehouse/import-histories' title={'Lịch sử nhập hàng'} hasBullet />
          )}
          {hasPermission(LIST_PERMISSIONS.WAREHOUSE_REPORT) && (
            <AsideMenuItem to='/warehouse-report' title={'Tình trạng tồn kho - Công nợ'} hasBullet />
          )}
        </AsideMenuItemWithSub>
      )}
      {hasPermission(LIST_PERMISSIONS.PAYMENT_REQUEST) && (
        <AsideMenuItem
          to='/payment-request'
            icon='/media/icons/duotune/finance/fin010.svg'
            title={'Yêu cầu thanh toán'}
            fontIcon='bi-app-indicator'
        />
      )}
      {(hasPermission(LIST_PERMISSIONS.ACCOUNTS)) && (
        <AsideMenuItemWithSub
          to='/accounts'
          icon='/media/icons/duotune/general/gen051.svg'
          title={intl.formatMessage({ id: 'MENU.ACCOUNT' })}
          fontIcon='bi-app-indicator'
        >
          <AsideMenuItem to='/accounts/list' title={intl.formatMessage({ id: 'MENU.ACCOUNT.LIST' })} icon='\media\icons\duotune\communication\com005.svg' />
          <AsideMenuItem to='/accounts/roles' title={intl.formatMessage({ id: 'MENU.ROLE.LIST' })} icon='\media\icons\duotune\coding\cod001.svg' />
        </AsideMenuItemWithSub>
      )}
    </>
  )
}
